// extracted by mini-css-extract-plugin
module.exports = {"file":"Folder_file__N0R5u"};